import React, { useState, useEffect } from "react";
import { Modal, Table, InputNumber, Form, Input } from "antd";
import { apiRequest } from "../../../service/apiRequest";
import { showError, showSuccess } from "../../../components/errorHandler";

interface CategoryItem {
  category_id: number;
  category_name: string;
  discount?: number;
  special_discount?: number;
}

interface DiscountModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
  categories: CategoryItem[];
  form: any;
  discounts: any[];
  ledgerId: number | null;
  setDiscounts: React.Dispatch<React.SetStateAction<any[]>>;
}


const DiscountModal: React.FC<DiscountModalProps> = ({
  open,
  onCancel,
  onOk,
  categories,
  form,
  discounts,
  setDiscounts,
  ledgerId
}) => {


  // Modal Component का useEffect हिस्सा (DiscountModal)


  useEffect(() => {
    if (!categories || categories.length === 0 || ledgerId === null) return;

    let initialDiscounts: any[] = [];

    if (discounts && discounts.length > 0) {
      // API से पहले से डाटा मिला है, इसे रखें
      initialDiscounts = discounts;
    } else {
      // API से डाटा नहीं आया, तो सभी categories के लिए डिस्काउंट को 0 से भरें
      initialDiscounts = categories.map((cat) => ({
        category_id: cat.category_id,
        category_name: cat.category_name,
        lcm_discount: cat.discount || 0,
        lcm_special_discount: cat.special_discount || 0,
        lcm_id: null,
      }));
    }

    // discounts स्टेट में सेट करें
    setDiscounts(initialDiscounts);

    // फॉर्म के fields भी अपडेट करें, ताकि इनपुट्स में यह दिखे
    form.setFieldsValue({ discounts: initialDiscounts });
  }, [categories, ledgerId]);




  // API से discounts array मान लीजिए discountsData

  const handleDiscountChange = (index: number, field: string, value: number) => {
    const updated = [...discounts];
    updated[index] = { ...updated[index], [field]: value };
    setDiscounts(updated);
  };

  const handleSaveDiscounts = async () => {
    try {
      if (!ledgerId) {
        showError("Invalid ledger ID");
        return;
      }

      for (const item of discounts) {
        const payload = {
          ledger_id: ledgerId,
          category_id: item.lcm_category_id || item.category_id,
          lcm_discount: item.lcm_discount || 0,
          lcm_special_discount: item.lcm_special_discount || 0,
        };

        if (item.lcm_id) {
          // 🔁 Update existing discount
          await apiRequest({
            method: 'put',
            url: `/ledger-category-mapping/${item.lcm_id}`,
            data: payload,
          });
        } else {
          // ➕ Add new discount
          await apiRequest({
            method: 'post',
            url: '/ledger-category-mapping',
            data: payload,
          });
        }
      }

      showSuccess("Discounts updated successfully!");
      onOk();
    } catch (err) {
      console.error(err);
      showError("Failed to save discounts");
    }
  };



  const columns = [
    {
      title: "Category Name",
      dataIndex: "category_name",
      key: "category_name",
    },
    {
      title: "Discount (%)",
      dataIndex: "lcm_discount",
      key: "lcm_discount",
      render: (_: any, record: any, index: number) => (
        <Form.Item
          name={["discounts", index, "lcm_discount"]}
          style={{ margin: 0 }}
          initialValue={record.lcm_discount}
        >
          <InputNumber
            min={0}
            max={100}
            step={0.01}
            // value={record.lcm_discount}
            onChange={(val) => handleDiscountChange(index, "lcm_discount", val || 0)}
            placeholder="0"
          />
        </Form.Item>
      ),
    },
    {
      title: "Special Discount (%)",
      dataIndex: "lcm_special_discount",
      key: "lcm_special_discount",
      render: (_: any, record: any, index: number) => (
        <Form.Item
          name={["discounts", index, "lcm_special_discount"]}
          style={{ margin: 0 }}
          initialValue={record.lcm_special_discount}
        >
          <InputNumber
            min={0}
            max={100}
            step={0.01}
            // value={record.lcm_special_discount}
            onChange={(val) =>
              handleDiscountChange(index, "lcm_special_discount", val || 0)
            }
            placeholder="0"
          />
        </Form.Item>
      ),
    },
  ];




  return (
    <Modal
      title="Category Discounts"
      open={open}
      onCancel={onCancel}
      onOk={handleSaveDiscounts}
      width="90%"
      centered
      maskClosable={false}
    >
      <Table
        columns={columns}
        dataSource={discounts}
        pagination={false}
        // rowKey="lcm_id"
        rowKey={(record) => record.lcm_id || record.category_id}
      />
    </Modal>
  );
};

export default DiscountModal;
